'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mergeProps;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Merge two sets of props so that where an originalProps prop is missing, use
 * the placeholderProps value, but inherit the original values where available.
 */
function mergeProps(originalProps, placeholderProps) {
  var mergedProps = {};

  [].concat(_toConsumableArray(Object.keys(originalProps)), _toConsumableArray(Object.keys(placeholderProps))).forEach(function (propName) {
    var prop = originalProps[propName];

    if (typeof prop !== 'undefined' && prop !== null) {
      mergedProps[propName] = originalProps[propName];
    } else {
      mergedProps[propName] = placeholderProps[propName];
    }
  });

  return mergedProps;
}